import { http, user } from 'services'
// initial state
const state = () => ({
  all: [],
  active: {},
  errors: null
})

// getters
const getters = {
}

// actions
const actions = {
  ['users.getAll'] ({ commit }, params) {
    if (!params._q) params._q = null

    commit('CLEAR_ERRORS')

    return (http.get('users', {
      params
    })).then ((res) => {
      commit('GET_ALL_USERS', res);
    })
    .catch ((res) => {
      commit('USERS_ERROR', res);
    })
  },
  ['users.newUser'] ({ commit }, data) {
    commit('CLEAR_ERRORS')

    data = _.cloneDeep(data)
    delete data.two_fa_action

    return (http.post('users', data))
    .then ((res) => {
      // commit('NEW_USER', res);
    })
    .catch ((res) => {
      commit('USERS_ERROR', res);
    })
  },
  ['users.editUser'] ({ commit }, {id, data}) {
    commit('CLEAR_ERRORS')
    data = _.cloneDeep(data)
    if (Object.prototype.hasOwnProperty.call(data, 'roles')) {
      delete data.two_fa_action
    }
    const currentUser = user.getUser()
    if (!currentUser || currentUser.type !== 'ims') {
      delete data.two_fa_action
    }
    return (http.put('users/' + id , data))
    .then ((res) => {
      commit('EDIT_USER', res);
    })
    .catch ((res) => {
      commit('USERS_ERROR', res);
    })
  },
  ['users.disable2fa'] ({ commit }, id) {
    commit('CLEAR_ERRORS')

    return (http.post('users/' + id + '/2fa/disable'))
    .then ((res) => {
      commit('DISABLE_USER_2FA', id);
      const currentUser = user.getUser()
      if (currentUser && currentUser.id == id) {
        commit('USER_UPDATED', { data: {
          two_factor_enabled: false,
          google2fa_enabled: false
        }});
      }
    })
    .catch ((res) => {
      commit('USERS_ERROR', res);
    })
  },
  ['users.removeUser'] ({ commit }, id) {
    commit('CLEAR_ERRORS')

    return (http.delete('users/' + id))
    .then ((res) => {
      commit('REMOVE_USER', id);
    })
    .catch ((res) => {
      commit('USERS_ERROR', res);
    })
  },
  ['users.getUser'] ({ dispatch, commit, state }, id) {
    commit('CLEAR_ERRORS')
    return dispatch('roles.getAll', {_all: true}).then(() => {
      return (http.get('users/' + id))
      .then ((res) => {
        commit('GET_USER', res);
      })
      .catch ((res) => {
        commit('USERS_ERROR', res);
      })
    })
  },
  ['users.getUserByEmail'] ({ dispatch, commit, state }, {type, params}) {
    commit('CLEAR_ERRORS')
    return (http.get('users/get/' + type, {
      params
    }))
    .then ((res) => {
      commit('GET_USER', res);
    })
    .catch ((res) => {
      commit('USERS_ERROR', res);
    })
  },
}

// mutations
const mutations = {
  GET_ALL_USERS (state, res) {

    state.all = res.data;
  },

  GET_USER (state, res) {
    state.active = res.data
  },

  DISABLE_USER_2FA (state, id) {
    if (!state.all || !state.all.data) return
    const item = _.find(state.all.data, (userItem) => userItem.id == id)
    if (item) {
      item.two_factor_enabled = false
      item.google2fa_enabled = false
    }
  },

  REMOVE_USER (state, id) {
    state.all.data = _.filter(state.all.data, (item) => item.id != id);
  },

  EDIT_USER (state, res) {
    state.active = res.data
  },
  // NEW_USER (state, res) {
  //   // state.all.data =
  // },

  //ERRORS
  USERS_ERROR (state, err) {
    try {
      state.errors = err.response.data;
    } catch (e) {
      state.errors = err;
    }
  },

  CLEAR_ERRORS (state) {
    state.errors = null
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
